import { useTranslation } from "react-i18next";

const UserManagementTopHeader = () => {
  const [t] = useTranslation('');

  return (
    <div className="header-top flex items-center justify-between">
      <h2 className="title">
        {t('user_management_list.title')}
      </h2>
    </div>
  )
}

export default UserManagementTopHeader;